import { connect } from 'react-redux';
import Viewer from './viewer';
import setActivePageIndex from '../../../shared/actions/setActivePageIndex';
import dispatchPrintEvent from '../../../shared/actions/print';
import { setInitialScale } from '../../../shared/actions/setScale';
import setDefaultPageSize from '../../../shared/actions/setDefaultPageSize';
import * as EnhancementActionCreators from '../../../shared/actions/enhancementActionCreators';
import { onUpdateFindControlState } from '../../utils/pdfjs/findApi';
import { multiplePanelsOpen } from '../../../shared/actions/sidebarUtils';

export function dispatchEnhancementEvent(dispatch) {
  return (data, event) => {
    const actionCreator = EnhancementActionCreators[data.handlerId];
    actionCreator(dispatch, data, event);
  };
}

const authors = ({ authorContext } = {}) => authorContext && authorContext.data && authorContext.data['author-group'];
const references = ({ referencesContext } = {}) => referencesContext && referencesContext.data && referencesContext.data['cross-refs'];

const mapStateToProps = state => ({
  sidePanelOpen: state.sidebar.isOpen,
  obscureViewer: multiplePanelsOpen(state),
  pdfDocument: state.pdfDocument,
  activePageIndex: state.activePageIndex,
  rotations: state.rotations,
  clientHeight: state.clientSize.height,
  clientWidth: state.clientSize.width,
  articleAuthors: authors(state),
  referencesContext: references(state),
  references: state.references,
  figures: state.figures.failed ? [] : state.figures.data,
  language: state.metadata && state.metadata.language,
  sidePanelWidth: state.sidebar.updatedPosition,
});

const mapDispatchToProp = dispatch => ({
  setActivePageIndex: index => dispatch(setActivePageIndex(index)),
  setInitialScale: width => dispatch(setInitialScale(width)),
  setDefaultPageSize: page => dispatch(setDefaultPageSize(page)),
  onUpdateFindControlState: event => onUpdateFindControlState(dispatch, event),
  dispatchEnhancementEvent: dispatchEnhancementEvent(dispatch),
  dispatchPrintEvent: isPrinting => dispatch(dispatchPrintEvent(isPrinting)),
});

export default connect(mapStateToProps, mapDispatchToProp)(Viewer);
